import React from 'react';
import BarcodeScanner from './BarcodeScanner';
import ScanHistoryModal from './ScanHistoryModal';
import CameraModal from './CameraModal';
import GalleryModal from './GalleryModal';

const ModalManager = ({
  // Barcode Scanner props
  showBarcodeModal,
  setShowBarcodeModal,
  handleBarcodeDetected,
  scanLoading,
  scanError,
  scannedProductData,
  showScannedProduct,
  onConfirmProduct,
  onRetryScanning,
  
  // Scan History props
  showScanHistory,
  setShowScanHistory,
  scanHistory,
  
  // Camera Modal props
  showCameraModal,
  setShowCameraModal,
  cameraResOptions,
  cameraResolution,
  setCameraResolution,
  webcamRef,
  handleCapture,
  
  // Gallery Modal props
  showGalleryModal,
  setShowGalleryModal,
  getRootProps,
  getInputProps,
  isDragActive,
}) => {
  return (
    <>      {/* Scan History Modal */}
      <ScanHistoryModal
        show={showScanHistory}
        scanHistory={scanHistory}
        onClose={() => setShowScanHistory(false)}
      />
        {/* Camera Modal */}
      <CameraModal
        show={showCameraModal}
        cameraResOptions={cameraResOptions}
        cameraResolution={cameraResolution}
        setCameraResolution={setCameraResolution}
        webcamRef={webcamRef}
        handleCapture={handleCapture}
        onClose={() => setShowCameraModal(false)}
      />
        {/* Gallery Modal */}
      <GalleryModal
        show={showGalleryModal}
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        isDragActive={isDragActive}
        onClose={() => setShowGalleryModal(false)}
      />
        {/* Barcode Scanner */}
      <BarcodeScanner
        show={showBarcodeModal}
        onDetected={handleBarcodeDetected}
        onClose={() => setShowBarcodeModal(false)}
        scanLoading={scanLoading}
        scanError={scanError}
        scannedProductData={scannedProductData}
        showScannedProduct={showScannedProduct}
        onConfirmProduct={onConfirmProduct}
        onRetryScanning={onRetryScanning}
      />
    </>
  );
};

export default ModalManager;
